import Tooltip from './component';

export default Tooltip;
